import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AddContactInfoRequest } from '@/types/entities/contactInfo';
import { AddAddressRequest } from '@/domains/addresses/types/api/requests/AddAddressRequest';
import { DeleteContactPayload } from '../sagas/types';

const contactSlice = createSlice({
  name: 'contacts',
  initialState: {},
  reducers: {
    deleteContact: (_, _action: PayloadAction<DeleteContactPayload>) => {},
    addContactAddress: (_, _action: PayloadAction<AddAddressRequest>) => {},
    addContactContactInfo: (_, _action: PayloadAction<AddContactInfoRequest>) => {},
  },
});

export const { deleteContact, addContactAddress, addContactContactInfo } = contactSlice.actions;

export const contactReducer = contactSlice.reducer;
export const contactReducerPath = contactSlice.reducerPath;
